import script from "./TokenListTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./TokenListTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./TokenListTableRow.vue?vue&type=style&index=0&id=660ac4f7&lang=scss"

const __exports__ = script;

export default __exports__